import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    preferredAccountNumberFormat: 'SPACEDBBAN',
    settingsDetails: {
        displayAccountRepresentatives: true,
    },
    copyIBANForForeignAccount: true,
    accountDetailCopyActionAvailableForType: ['CURRENT'],
};
